export const CHANGE_YEAR = 'CHANGE_YEAR';
export const CHANGE_MONTH = 'CHANGE_MONTH';

export const CHANGE_PRIMARY = 'CHANGE_PRIMARY';
export const CHANGE_SECONDARY = 'CHANGE_SECONDARY';
export const CHANGE_URL = 'CHANGE_URL';